import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { Calendar, MapPin } from "lucide-react";

function formatDate(d, lang) {
  try {
    const date = new Date(d);
    return date.toLocaleDateString(lang === "ta" ? "ta-IN" : "en-IN", { day: "numeric", month: "long", year: "numeric" });
  } catch { return d; }
}

export default function EventsSection({ events = [] }) {
  const { t, lang } = useLang();
  const fontH = lang === "ta" ? "font-serif-ta" : "font-serif-en";

  return (
    <section id="events" data-testid="events-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="text-xs uppercase tracking-[0.3em] text-amber-700">أحداث</span>
          <h2 data-testid="events-heading" className={`${fontH} text-4xl md:text-5xl text-emerald-950 mt-2`}>
            {t("events_heading")}
          </h2>
        </div>

        {events.length === 0 ? (
          <div className="text-center text-stone-500">{t("no_events")}</div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {events.map((e, i) => {
              const title = lang === "ta" && e.title_ta ? e.title_ta : e.title_en;
              const desc = lang === "ta" && e.description_ta ? e.description_ta : e.description_en;
              return (
                <article key={e.id} data-testid={`event-${i}`} className="mosque-card p-6">
                  <div className="flex items-center gap-2 text-amber-700 text-xs uppercase tracking-widest mb-3">
                    <Calendar className="w-3.5 h-3.5" />
                    {formatDate(e.event_date, lang)}
                  </div>
                  <h3 className={`${fontH} text-2xl text-emerald-950`}>{title}</h3>
                  {desc && <p className="mt-3 text-stone-600 text-sm leading-relaxed">{desc}</p>}
                  {e.location && (
                    <div className="mt-4 flex items-center gap-1.5 text-stone-500 text-xs">
                      <MapPin className="w-3.5 h-3.5" /> {e.location}
                    </div>
                  )}
                </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
